import React from "react";
import PublicPage from "./PublicPage";

const ENTRIES = [
    {
        v: "0.9.3", date: "Jul 2026",
        highlights: [
            "Dashboard: FY selector + range label; Current-FY chart now caps at today.",
            "Customer Statement: number alignment fix in aging + summary cards.",
            "AI Copilot: markdown rendering (bold, headings, lists, tables).",
            "E-Invoice & E-Way Bill previews: formatted document view + collapsible raw JSON.",
        ],
    },
    {
        v: "0.9.2", date: "Jul 2026",
        highlights: [
            "New marketing landing page with 'Book a demo' flow (Resend email).",
            "Sidebar sections now collapsed by default; dark-navy nav with gold logo.",
            "Bank account creation bug fixed (empty opening balance).",
        ],
    },
    {
        v: "0.9.1", date: "Jun 2026",
        highlights: [
            "Admin analytics dashboard with auth_events logging.",
            "Universal PDF viewer + generated user guide & pitch documents.",
            "Mobile PWA readiness (icons, splash, manifest, deep-linking).",
        ],
    },
    {
        v: "0.9.0", date: "Jun 2026",
        highlights: [
            "Accounting engine v1: double-entry ledger, journals, trial balance, P&L, balance sheet, cash flow.",
            "Invoicing, bills, payments, credit/debit notes, delivery challans.",
            "GST: GSTR-1/3B/2B, e-invoice, e-way bill (simulated NIC endpoints).",
            "Banking, reconciliation, bank rules, transfers, multi-currency.",
            "Reports hub: 12 reports incl. AR/AP aging, sales by customer, cash forecast.",
        ],
    },
];

export default function Changelog() {
    return (
        <PublicPage kicker="&gt; releases" title="Changelog" testid="page-changelog">
            <p>We ship weekly. Here's what's new.</p>
            <div style={{ marginTop: 28, display: "grid", gap: 24 }}>
                {ENTRIES.map((e) => (
                    <div key={e.v} style={{ borderTop: "1px solid rgba(19,25,46,0.14)", paddingTop: 20 }} data-testid={`changelog-${e.v}`}>
                        <div style={{ display: "flex", alignItems: "baseline", gap: 12 }}>
                            <span style={{ fontFamily: "IBM Plex Mono, monospace", fontSize: 15, fontWeight: 600, color: "var(--vy-navy)" }}>v{e.v}</span>
                            <span style={{ fontSize: 12, color: "rgba(19,25,46,0.55)", fontFamily: "IBM Plex Mono, monospace" }}>{e.date}</span>
                        </div>
                        <ul style={{ marginTop: 10 }}>
                            {e.highlights.map((h, i) => <li key={i}>{h}</li>)}
                        </ul>
                    </div>
                ))}
            </div>
        </PublicPage>
    );
}
